import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashedChecksHistoryReport extends Layout {
    sourceFuelWireHistory: DataSource;
    textboxCardProvider: Textbox;
    textboxDate: Textbox;
}
